(function () {
  var toggle = document.getElementById("index-toggle");
  var panel = document.getElementById("index-panel");

  function closeMenu() {
    if (!panel || !toggle) return;
    panel.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
    toggle.textContent = "Index";
  }

  if (toggle && panel) {
    toggle.addEventListener("click", function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.textContent = open ? "Close" : "Index";
    });
    panel.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });
  }

  document.querySelectorAll("[data-slot]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-slot");
      document.querySelectorAll("[data-slot]").forEach(function (other) {
        var on = other === btn;
        other.setAttribute("aria-pressed", on ? "true" : "false");
        other.classList.toggle("is-on", on);
      });
      document.querySelectorAll("[data-room-panel]").forEach(function (pane) {
        pane.hidden = pane.getAttribute("data-room-panel") !== id;
      });
    });
  });

  var align = document.getElementById("align-moons");
  var list = document.getElementById("catalogue-list");
  if (align && list) {
    align.addEventListener("click", function () {
      var on = align.getAttribute("aria-pressed") !== "true";
      align.setAttribute("aria-pressed", on ? "true" : "false");
      align.textContent = on ? "Moons aligned · 148 cm" : "Align the moons";
      list.classList.toggle("is-aligned", on);
    });
  }

  function pressed(which) {
    return document.querySelector('[data-pair="' + which + '"][aria-pressed="true"]');
  }

  function renderPair() {
    var a = pressed("a");
    var b = pressed("b");
    var stage = document.getElementById("pair-stage");
    var same = document.getElementById("pair-same");
    if (!a || !b || !stage || !same) return;
    if (a.getAttribute("data-id") === b.getAttribute("data-id")) {
      stage.hidden = true;
      same.hidden = false;
      return;
    }
    same.hidden = true;
    stage.hidden = false;
    stage.innerHTML = "";
    [a, b].forEach(function (btn) {
      var id = btn.getAttribute("data-id");
      var card = document.querySelector('#weather-bank [data-weather="' + id + '"]');
      if (card) stage.appendChild(card.cloneNode(true));
    });
  }

  document.querySelectorAll("[data-pair]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var which = btn.getAttribute("data-pair");
      document.querySelectorAll('[data-pair="' + which + '"]').forEach(function (other) {
        var on = other === btn;
        other.setAttribute("aria-pressed", on ? "true" : "false");
        other.classList.toggle("is-on", on);
      });
      renderPair();
    });
  });

  var form = document.getElementById("viewing-form") || document.querySelector("#leaving form");
  if (form) {
    form.addEventListener("submit", function () {
      var words = document.getElementById("words");
      if (!words) return;
      var acting = form.querySelector("[name=acting]:checked");
      var ask = form.querySelector("[name=ask]:checked");
      var canvas = document.getElementById("canvas");
      var own = words.value.trim();
      var lines = [];
      if (acting) lines.push("Acting for: " + acting.value);
      if (ask) lines.push("Asking to see: " + ask.value);
      if (ask && ask.value === "A single canvas" && canvas) lines.push("Canvas: " + canvas.value);
      if (own) lines.push("", own);
      words.value = lines.join("\n");
    });
  }

  var titles = {
    "witness-i": "MC 01  The Hour the Trees Kept — Moon and Clouds",
    "fault-i": "MC 02  The Life Offshore — Moon and Clouds",
    "mirror-i": "MC 03  The Color That Outlived the Day — Moon and Clouds",
    "far-weather": "MC 04  Far Weather — Moon and Clouds"
  };

  function retitle() {
    var id = decodeURIComponent((location.hash || "").replace(/^#/, ""));
    document.title = titles[id] || "Moon and Clouds";
  }

  window.addEventListener("hashchange", retitle);
  retitle();
})();
